import { lazy } from "react";

export const KoalaPhrasePage = lazy(() => import("./koalaPhrasePage"));
